import React, {useContext, useEffect, useState} from 'react';
import './navbar.scss';
import {Link, useNavigate} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faChartSimple, faDoorOpen,
    faGlobe, faLanguage, faPlane,
    faMapLocationDot, faMoon,
    faScaleBalanced, faSun,
    faUsers
} from "@fortawesome/free-solid-svg-icons";
import {ThemeContext} from "../theme-context/theme-context";
import {AuthContext} from "../auth-context/auth";
import {useTranslation} from "react-i18next";

const Navbar = () => {
    const { t } = useTranslation();
    const { theme, toggleTheme } = useContext(ThemeContext);
    const [menuOpen, setMenuOpen] = useState(false);
    const { isAuthenticated, logout } = useContext(AuthContext);

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };
    
    const closeMenu = () => {
        setMenuOpen(false);
    };

    const handleLogout = () => {
        logout();
        closeMenu();
        window.location.href = '/login';
    };

    return (
        <nav className={`navbar ${menuOpen ? 'open' : ''}`}>
            <div className="navbar-logo">
                <Link to="/">
                    <img className="logo-png" src="/resources/HiCrew.png" alt="Logo Airline"/>
                </Link>
            </div>

            <div className="hamburger" onClick={toggleMenu}>
                {menuOpen ? '✖' : '☰'}
            </div>

            <div className={`navbar-menu ${menuOpen ? 'open' : ''}`}>
                <div className="navbar-nav">
                    {isAuthenticated && (
                        <Link to="/manager" onClick={closeMenu}><FontAwesomeIcon icon={faPlane} /> {t('volar') || t('manager')}</Link>
                    )}
                    <Link to="/central" onClick={closeMenu}><FontAwesomeIcon icon={faMapLocationDot} /> {t('central')}</Link>
                    <Link to="/pilots" onClick={closeMenu}><FontAwesomeIcon icon={faUsers} /> {t('pilots')}</Link>
                    <Link to="/rules" onClick={closeMenu}><FontAwesomeIcon icon={faScaleBalanced} /> {t('rules')}</Link>
                    <Link to="/stats" onClick={closeMenu}><FontAwesomeIcon icon={faChartSimple} /> {t('stats')}</Link>
                    <div className="navbar-icons">
                        <Link to="#" onClick={(e) => { e.preventDefault(); toggleTheme(); closeMenu(); }}>
                            <FontAwesomeIcon icon={theme === 'light' ? faMoon : faSun} />
                        </Link>
                        <Link to="/lang" onClick={closeMenu}><FontAwesomeIcon icon={faLanguage} /></Link>
                        {isAuthenticated && (
                            <Link to="#" onClick={handleLogout}>
                                <FontAwesomeIcon icon={faDoorOpen} />
                            </Link>
                        )}
                    </div>
                </div>
                <div className="navbar-login">
                    {isAuthenticated ? (
                        <Link to="/profile" onClick={closeMenu}>{t('profile')}</Link>
                    ) : (
                        <Link to="/login" onClick={closeMenu}>{t('login')}</Link>
                    )}
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
